import React from 'react';
import styled from 'styled-components';
import { Spacer, Text } from '@ontruck/orc';

const t = {
  status: {
    ONROUTE: 'Started',
    PENDING: 'Arrived',
    DONE: {
      DROPOFF: 'Unloaded',
      PICKUP: 'Loaded',
    },
  },
};

const Uppercased = styled.span`
  text-transform: uppercase;
`;

const Status = ({ changes: { stage, stop_type, stop_company_name }, ...props }) => {
  if (!stage) {
    return null;
  }

  const stageStatus =
    typeof t.status[stage] === 'string' ? t.status[stage] : t.status[stage][stop_type];

  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        <Uppercased>{stageStatus}</Uppercased> - {stop_company_name}
      </Text>
    </Spacer>
  );
};

export default Status;
